<template>
    <div class="box-page">
        <div class="page-header with-underline">
            <span class="page-title">พิมพ์รายงาน</span>
        </div>
        <div class="page-content">
            <div class="row with-underline pb-4">
                <div class="col-md-8">
                    <div>
                        <div class="page-subtitle">
                            <span>พิมพ์รายการถอน</span>
                        </div>
                        <div class="d-flex align-items-center">
                            <div id="wgCalendar" class="wgCalendar-large mr-3"></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 my-auto">
                    <div class="text-right">
                        <button id="btnPrint" class="btn" @click="exportExcel">พิมพ์</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        data: function () {
            return {

            }
        },
        mounted() {
        },
        created() {
            this.buildDatepicker();
        },
        computed: {
        },
        methods: {
            buildDatepicker() {
                const vm = this;
                $(document).ready(function () {
                    $('#wgCalendar').wgCalendar({
                        submitDate: function(data, self) {
                            if (data.isAllDate) {
                                vm.startDate = null;
                                vm.endDate = null;
                            } else {
                                vm.startDate = data.startDate;
                                vm.endDate = data.endDate;
                            }
                        }
                    });
                });
            },
            exportExcel() {
                const startDate = this.startDate ? moment(this.startDate).format('YYYY-MM-DD') : null;
                const endDate = this.endDate ? moment(this.endDate).format('YYYY-MM-DD') : null;
                const params = {
                    startDate: startDate,
                    endDate: endDate,
                };
                axios.post(`${this.baseUrl}/admin/withdraw/api/export-excel`, params).then(({ data }) => {
                    if (data != null && data.data != null) {
                        console.log('data.data', data.data);
                        var report = XLSX.utils.json_to_sheet(data.data);
                        var wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, report, 'Withdraw template');
                        const time = moment().format('YYYY-MM-DD_HH:mm:ss');
                        XLSX.writeFile(wb, `goobank_withdraw_${time}.xlsx`);
                    } else {
                        alertbox('ไม่มีข้อมูล');
                    }
                });
            },
        },
        props: {
            baseUrl: '',
            storagePath: '',
        },
    }
</script>

<style lang="scss" scoped>

</style>



